import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/data";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <span className="eyebrow">What we do</span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 text-[#041047] tracking-tight leading-[1.1]">
              Services built to <em className="italic font-medium">scale</em> your business online.
            </h2>
          </div>
          <p className="lg:col-span-5 text-[#475569] text-lg leading-relaxed">
            From the first click to the final conversion — we engineer every stage of your
            digital growth with strategy, creativity and measurable performance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#041047]/10">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${i}`}
                className="bg-white p-8 md:p-10 group cursor-pointer transition-all duration-300 hover:bg-[#FDFBFA] relative"
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="w-12 h-12 border border-[#041047]/15 flex items-center justify-center group-hover:bg-[#041047] group-hover:border-[#041047] transition-colors">
                    <Icon className="w-5 h-5 text-[#041047] group-hover:text-white transition-colors" />
                  </div>
                  <span className="font-display text-sm text-[#D4AF37]">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-display text-2xl md:text-[1.65rem] text-[#041047] mb-3">
                  {s.title}
                </h3>
                <p className="text-[#475569] leading-relaxed text-[0.95rem]">{s.desc}</p>
                <a
                  href="#contact"
                  data-testid={`service-cta-${i}`}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#041047] group-hover:text-[#D4AF37] transition-colors"
                >
                  Learn more <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
